import {AxiosInstance} from "axios";
import JobStatus from "../model/job/JobStatus";
import JobWarrantyRegistrationStatus from "../model/job/JobWarrantyRegistrationStatus";

/**
 * Api for job status.
 */
export default class JobStatusApi {
	constructor(public readonly axiosInstance: AxiosInstance) { }

	/**
	 * Fetch job statuses.
	 * @returns {Promise<JobStatus[]>} Promise containing all job statuses.
	 */
	fetchJobStatuses(): Promise<JobStatus[]> {
		const url = `/api/web/jobs/statuses`;
		return this.axiosInstance.get(url).then(resp => resp.data.map(JobStatus.fromJson));
	}

	/**
	 * Fetch job warranty registration statuses.
	 * @returns {Promise<JobWarrantyRegistrationStatus[]>} Promise containing all job statuses.
	 */
	fetchJobWarrantyRegistrationStatus(): Promise<JobWarrantyRegistrationStatus[]> {
		const url = `/api/web/warranty_registration_statuses`;
		return this.axiosInstance.get(url).then(resp => resp.data.map(JobWarrantyRegistrationStatus.fromJson));
	}

	/**
	 * Create job status action.
	 */
	createJobStatus(data: JobStatus): Promise<JobStatus> {
		const url = `/api/web/jobs/statuses`;
		return this.axiosInstance.post(url, data.toJson()).then(resp => JobStatus.fromJson(resp.data));
	}

	/**
	 * Edit job status action.
	 */
	editJobStatus(jobStatusId: string, data: JobStatus): Promise<JobStatus> {
		const url = `/api/web/jobs/statuses/${jobStatusId}`;
		return this.axiosInstance.put(url, data.toJson()).then(resp => JobStatus.fromJson(resp.data));
	}

	/**
	 * Update job status sort order.
	 * @returns {Promise<JobStatus[]>}
	 * @param jobStatuses
	 */
	updateSortOrder(jobStatuses: JobStatus[]) {
		const url = `/api/web/jobs/statuses/order`;
		const jobStatusesIds = jobStatuses.map(js => js.id);
		return this.axiosInstance.put(url, jobStatusesIds);
	}

	/**
	 * Change job status suspend
	 * @param {string} jobStatusId
	 * @param {boolean} disabled
	 * @returns {AxiosPromise<any>}
	 */
	changeSuspend(jobStatusId: string, disabled: boolean) {
		const url = `/api/web/jobs/statuses/${jobStatusId}/disabled`;
		return this.axiosInstance.put(url, {disabled})
	}
}
